/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2018
 */

/* global angular */

/**
 * nexleaderComponentRaliFrame
 *
 * angular component
 *
 * Embeds an ECourse module video in an iFrame. The videos were hosted on Rali until it shut down; they now
 *  play from Vimeo, and raliId is the Vimeo video id. The Rali names are historical.
 */
import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-nexleader-rali-frame',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rali-frame.component.html',
})
export class NexleaderRaliFrameComponent implements OnInit {
  /**
   * raliId
   *
   * string
   *
   * A string representing the ID of the Rali video we want to embed. This comes from Steve, who gets it
   *  from creating contexnt in Rali.
   */
  @Input() raliId: string = 'hyz1u6n1adynbmmc1ykmbz0bxskko54i';
  videoUrl!: SafeResourceUrl;

  /**
   * RALI_PLAYER_URL_PREFIX
   *
   * @type {string} the prefix of the URL preprended to the video id before handing it off to the rali embed code
   */
  private readonly RALI_PLAYER_URL_PREFIX = 'https://player.vimeo.com/video/';

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    // Ensure we have the Rali ID
    if (!this.raliId) {
      throw new Error(
        'nexleaderDataRaliId is required for nexleaderComponentRaliFrame; See binding documentation.'
      );
    }

    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.RALI_PLAYER_URL_PREFIX + this.raliId);
  }
}
